var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入活动名称" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.title,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "title", $$v)
              },
              expression: "listQuery.title",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "140px" },
              attrs: { placeholder: "启用状态", clearable: "" },
              on: { change: _vm.handleFilter },
              model: {
                value: _vm.listQuery.enabled,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "enabled", $$v)
                },
                expression: "listQuery.enabled",
              },
            },
            [
              _c("el-option", { attrs: { label: "已启用", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "已禁用", value: 0 } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v("\n      添加口令活动\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "加载中",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "编号", prop: "id", width: "70", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动名称",
              prop: "title",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "封面图", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.imgUrl
                      ? _c("el-image", {
                          staticStyle: {
                            width: "40px",
                            height: "40px",
                            "border-radius": "4px",
                          },
                          attrs: {
                            src: _vm.getImageUrl(scope.row.imgUrl),
                            fit: "cover",
                            "preview-src-list": [
                              _vm.getImageUrl(scope.row.imgUrl),
                            ],
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "活动时间", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "line-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("formatShort")(scope.row.startTime)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "line-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("formatShort")(scope.row.endTime)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "库存", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "line-text" }, [
                      _vm._v(
                        "\n          猜对: " +
                          _vm._s(
                            scope.row.remaining == null
                              ? 0
                              : scope.row.remaining
                          ) +
                          "/" +
                          _vm._s(
                            scope.row.allStock == null ? 0 : scope.row.allStock
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "line-text" }, [
                      _vm._v(
                        "\n          猜错: " +
                          _vm._s(
                            scope.row.errorRemaining == null
                              ? 0
                              : scope.row.errorRemaining
                          ) +
                          "/" +
                          _vm._s(
                            scope.row.allStockError == null
                              ? 0
                              : scope.row.allStockError
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "参与数据", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "line-text" },
                      [
                        _c("span", [_vm._v("按参与:")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "join-num",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleJoinClick(scope.row, "all")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.joinCount || 0) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "line-text" },
                      [
                        _c("span", [_vm._v("答对:")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "join-num",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleJoinClick(scope.row, 1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.okCount || 0) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "join-gap" }, [
                          _vm._v("答错:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "join-num",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleJoinClick(scope.row, 2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.errCount || 0) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "启用", align: "center", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleStatus(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.isEnable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "isEnable", $$v)
                        },
                        expression: "scope.row.isEnable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "300",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#E6A23C" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleJoin(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          参与明细\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#67C23A" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCopy(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          复制\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#E6A23C" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleQrcode(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          二维码\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#F56C6C" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          删除\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.handlePagination,
        },
      }),
      _vm._v(" "),
      _c("activity-qrcode-dialog", {
        attrs: {
          visible: _vm.qrcodeDialogVisible,
          title: _vm.qrTitle,
          items: _vm.qrItems,
        },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }